<template>
    <div class="content-wapper">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item>融资服务</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <!--
            <el-col :span="6" style="height: 100%;">
                <el-row class="left-img">
                    <img src="@/assets/images/xwqyczfw/rzfw/1.png"/>
                </el-row>
                <el-row class="menu-box" style="min-height: 340px;">
                    <el-row>
                        <el-col :span="6" align="left" style="width: 25px">
							<img src="@/assets/images/xwqyczfw/rzfw/rzfw_product.png" style="border: 0px solid red;padding-top: 4px"/>
						</el-col>
                        <el-col :span="12" align="left">
                       <div style="color:#5173D2;font-size: 20px;font-weight: bold;border:0px solid red" align="left" >
                           <span>融资服务产品</span>
                       </div>
                    </el-col>
                    </el-row>
                    <hr style="border:1px solid #CACCD0">
                    <el-menu :default-active="menuCode"
                             class="el-menu-vertical-demo"
                             text-color="#000"
                             active-text-color="#409eff"
                             @select="handleSelect">
                        <template v-for="item in menulist">
                            <el-menu-item :index="item.recid" >
                               <img :src="getImgUrl(item.imgPath)" style="width: 1.125rem;height: 1.125rem;margin-right: 1rem;"/>
                                <span>{{item.yhName}}</span>
                            </el-menu-item>
                        </template>
                    </el-menu>
					<el-col :span="24">
						<div class="xqsq" @click="openPageXqsq('/main/xwqyczfw/xqsq')">
							<span>小微企业融资需求申请</span>
						</div>
					</el-col>
                </el-row>
            </el-col>
            -->
            <el-col :span="6">
                <el-row class="left-img">
                    <img src="@/assets/images/xwqyczfw/rzfw/1.png"/>
                </el-row>

                <el-row class="menu-box" style="min-height: 340px;">
                    <el-row>
                        <el-col :span="6" align="left" style="width: 25px">
                            <img src="@/assets/images/xwqyczfw/rzfw/rzfw_product.png" style="border: 0px solid red;padding-top: 4px"/>
                        </el-col>
                        <el-col :span="12" align="left">
                            <div style="color:#5173D2;font-size: 20px;font-weight: bold;border:0px solid red" align="left" >
                                <span>融资服务产品</span>
                            </div>
                        </el-col>
                    </el-row>

                    <hr style="border:1px solid #CACCD0">
                    <div v-for="(item, index) in menulist" :key="item.recid">
                        <div class="menu-level1" @click="changeMenu2(item.yhName,item.recid)">
                            <el-row style="margin-top: 3px">
                                <el-col :span="3">
                              <img :src="getImgUrl(item.imgPath)" style="width: 1.125rem;height: 1.125rem;"/>
                                </el-col>
                                <el-col :span="18">
                                    <span style="margin-top: 31px">{{item.yhName}}</span>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <hr style="border:1px solid #CACCD0">
                    <el-col :span="24">
                        <div class="xqsq" @click="openPageXqsq('/main/xwqyczfw/xqsq')">
                            <span>小微企业融资需求申请</span>
                        </div>
                    </el-col>
					<hr style="border:1px solid #CACCD0">
					<el-col :span="24">
					    <div class="xqsq" @click="listshow = false;lxfs = true;menuTitle = '联系方式'">
					        <span>联系方式</span>
					    </div>
					</el-col>
                </el-row>
            </el-col>

            <el-col :span="18" class="right-box" >
                <el-row class="right-box-row" style="min-height: 430px;">
                    <el-row class="right-box-row-title">
                        {{menuTitle}}
                    </el-row>
					<div v-show="listshow">
						<el-table  v-loading="loading" :data="list" :show-header="false" tooltip-effect="light">
						    <el-table-column align="left" :show-overflow-tooltip="true" prop="rzfwcpglTitle"  >
						        <template slot-scope="scope" >
						            <span @click="openPage(scope.row)" class="rzfwcpglTitle">{{ scope.row.rzfwcpglTitle }}</span>
						        </template>
						    </el-table-column>
						    <el-table-column label="日期" align="center" prop="rzfwcpglFbtime" :width="180">
								<template slot-scope="scope">
								    <span >{{ parseTime(scope.row.rzfwcpglFbtime, '{y}-{m}-{d}') }}</span>
								</template>
							</el-table-column>
							<el-table-column align="right">
								<el-button type="primary" @click="openNewPage('/main/zxzxForm')">在线咨询</el-button>
							</el-table-column>
						</el-table>
						<pagination
						        v-show="total>0"
						        :total="total"
						        :page.sync="queryParams.pageNum"
						        :limit.sync="queryParams.pageSize"
						        @pagination="getList"
						/>
					</div>
                    <div v-show="lxfs">
						<el-row style="padding: 20px;">
							<el-col :span="24">
								邮储银行威海市分行 融资专员：甄洁  0631-5800172
							</el-col>
						</el-row>
						<el-row style="padding: 20px;">
							<el-col :span="24">
								威海市商业银行融资专员：张楠 0631-5226280
							</el-col>
						</el-row>
						<el-row style="padding: 20px;">
							<el-col :span="24">
								威海农商银行融资专员：田飞 0631-5690966
							</el-col>
						</el-row>
					</div>
                </el-row>
            </el-col>
        </el-row>

    </div>
</template>

<script>
	import { listYhgl } from "@/api/xwqy/yhgl";
	import { listRzfwcpgl, getRzfwcpgl, delRzfwcpgl, addRzfwcpgl, updateRzfwcpgl, exportRzfwcpgl } from "@/api/xwqy/rzfwcpgl";
    import {updatePvNum} from "@/api/itempv/pv";


    export default {
        name: "djyl",
        data() {
            return {
                menulist:[],
                menuTitle:undefined,
                menuCode:undefined,
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list:[],
                queryParams:{
                    pageNum:1,
                    pageSize:10,
					yhglRecid:undefined
                },
				en:undefined,
				listshow:true,
				lxfs:false,
                isActive: "威海市商业银行",
                isActive2: "0101",
                isCollapse: "威海市商业银行",
                menuIcon: 'menu-icon',
                menuIconDown: 'menu-icon-down',
                menuList: undefined,/*[
                    {
                        name: '威海市商业银行',
                        /!*labels: [{
                            label: '商业银行',*!/
                            code: "0101"
                        /!*}]*!/
                    },
                    {
                        name: '威海市农商银行',
                        /!*labels: [{
                            label: '农商银行',*!/
                            code: "0201"
                        /!*}]*!/
                    },
                    {
                        name: '邮政银行威海市分行',
                        /!*labels: [{
                            label: '邮政银行',*!/
                            code: "0301"
                       /!* }]*!/
                    }
                ],*/
            }
        },
        created() {
			const de = JSON.parse(localStorage.getItem('xwqyczfwRzfw'));
			this.en = de;
			// console.log("xwqyczfwRzfw==>",this.en);
			if (this.en != undefined && this.en != "") {
				this.queryParams.yhglRecid = this.en.recid;
				this.menuTitle = this.en.yhName;
				this.getList();
			}
            this.getYhglList();
			/*
			setTimeout(function() {
				this.clearlocalStorage();
			}, 1000);
			*/
        },
        methods: {
            changeMenu(name, code) {
                this.isCollapse = name;
                this.isActive = name;
                this.isActive2 = undefined;
            },
            changeMenu2(name,recid) {
				this.listshow = true;
				this.lxfs = false;
                this.loading = true;
                this.isActive = name;
				this.menuTitle = name;
				this.queryParams.pageNum = 1;
				this.queryParams.yhglRecid = recid;
				this.getList();
                updatePvNum("xwqycz_rzfw_rzfwcp").then(response => {
                    //pv 点击融资服务产品
                });
            },
			changeMenu3() {
				this.menuTitle = name;
				
			},
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getList();
            },
			getYhglList(){
				this.menulist = [];
				listYhgl(this.queryParams).then(response => {
                    //debugger
				  this.menulist = response.rows;
				  // console.log(this.menulist)
				  if (this.menulist.length>0 && (this.en === undefined || this.en === null || this.en === "") ) {
                      this.queryParams.yhglRecid=this.menulist[0].recid;
					  this.menuTitle=this.menulist[0].yhName;
				  }
				  this.getList();
				});
			},
            getList() {
                this.loading = true;
				// this.queryParams.yhglRecid = this.menuCode;
				listRzfwcpgl(this.queryParams).then(response => {
				  this.list = response.rows;
				  for (let i = 0; i < this.list.length; i++) {
				    this.list[i].rzfwcpglContent = this.replaceImgSrc(this.list[i].rzfwcpglContent)
				  }
				  this.total = response.total;
				  this.loading = false;
				});
                this.loading = false;
            },

            handleSelect(key, keyPath) {
                this.queryParams.yhglRecid=key;
                for (let item of this.menulist){
                    if(item.recid==key){
                        this.menuTitle=item.yhName;
                    }
                }
                this.queryParams.pageNum = 1;
                this.getList();
            },
            openDetail(item){
                this.$router.push({
                    path: '/main/xwqyczfw/rzfw/detail/'+this.queryParams.yhglRecid+'/'+item.recid
                })
                this.$store.commit('SET_MAININDEX', '/main/rzfw');
            },
            openPage(item){
                localStorage.setItem("rzfwDetail",JSON.stringify(item));
                this.utils.windowOpen('/main/xwqyczfw/rzfw/detail');
            },
			openNewPage(url) {
				console.log(url);
				//----【】需要修改为recid
				//单点登录跳转
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (this.utils.isLoginTimeout()) {
					this.utils.windowOpen(url);
				} else {
					if (ssessionLoginUser != null) {
						let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
						this.$confirm(
								'登录请求已过期，您可以继续留在该页面，或者重新登录?',
								'系统提示', {
									confirmButtonText: '重新登录',
									cancelButtonText: '取消',
									type: 'warning'
								}
						).then(() => {
							this.logout(ywFwjgRecid)
						})
					} else {
						swal( "登录提示", "请先登录企业工作室，再进行数据提报，谢谢！","warning",{button: true}).then((value) => {
							// swal(`The returned value is: ${value}`);
							localStorage.clear();
							window.location.href = this.Config.sdtyrzfwLoginUrl;
						});
					}
				}
			},
			openPageXqsq(url){
                if (url == '/main/xwqyczfw/xqsq') {
					//----【】需要修改为recid
					let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
					if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
						updatePvNum("xwqycz_rzfw_xwqyrzxqsq").then(response => {
						    //pv 点击小微企业融资需求申请
						});
						// this.utils.windowOpen(url);
                        this.toPage(url);
					} else {
						window.location.href = this.Config.sdtyrzfwLoginUrl;
					}
                }else{
                    // this.utils.windowOpen(url);
                    this.toPage(url);
                }
			},
			clearlocalStorage(){
                localStorage.removeItem("xwqyczfwRzfw");
			}
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .left-img img{
        width: 100%;
    }
    .menu-box{
        background-color: #FAFAFA;
        padding: 15px 10px;
    }
    .menu-level1 {
        padding: 10px;
        background-color: #eeeeee;
        padding-left: 20px;
        font-size: 13px;
        text-align: left;
        margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
    }

    .menu-level2 {
        padding: 5px 20px 5px 20px;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
    }

    /deep/.el-menu{
        text-align: left;
        background-color:#FAFAFA;
        border:0;
    }
    .el-menu-item{
        margin-bottom: 10px;
        background-color:#EAEAEA;
    }
    /*
    .menu-box /deep/ .el-menu-item.is-active{
        background-color:#EBEFF8;
    }
    */
    .right-box{
        padding-left: 10px;
    }
    .right-box-row{
        border: 1px solid #cccccc;
        padding: 10px 15px 0;
    }
    .right-box-row-title{
        padding: 5px 0;
        text-align: left;
        color: #5570D5;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin: 10px 0;
    }
    /deep/.title:hover{
        color: #1482f0;
        cursor: pointer;
    }
	.xqsq{
		min-height: 3rem;
		background-color: #ffaa00;
		color: #FFFFFF;
		font-size: 1.15rem;
		line-height: 3rem;
		border-radius: 0.0625rem;
		cursor: pointer;
	}
	.rzfwcpglTitle {
		cursor: pointer;
	}
	.rzfwcpglTitle:hover{
		color: #409EFF;
	}
</style>